export type PublisherGameType = "all" | "game" | "dlc" | "demo";

export type PublisherGameTypeOption = {
  value: PublisherGameType;
  label: string;
};

export const PUBLISHER_GAME_TYPES: PublisherGameTypeOption[] = [
  { value: "all", label: "All" },
  { value: "game", label: "Game" },
  { value: "dlc", label: "DLC" },
  { value: "demo", label: "Demo" },
];

export function normalizePublisherGameType(
  type: string | undefined,
): PublisherGameType {
  const value = (type ?? "all").trim().toLowerCase();
  return PUBLISHER_GAME_TYPES.some((t) => t.value === value)
    ? (value as PublisherGameType)
    : "all";
}

export function getPublisherGameTypeSelectOptions(): PublisherGameTypeOption[] {
  return PUBLISHER_GAME_TYPES;
}
